export default "__VITE_ASSET__DESXGPK2__"